<!-- Our Way Component -->
<script>
  import { Col, Row, Container} from "sveltestrap";

  export let ourwayData = {};
  const { title, text, feature_list } = ourwayData;
</script>

<!--END ABOUT US-->
<section class="section common-section" id="ourway">
  <Container>
    <Row class="vertical-content">
      <Col lg="5">
        <div class="features-box">
          <h3>
            {title}
          </h3>
          <p class="text-muted web-desc">
            {text}
          </p>
          <ul class="text-muted list-unstyled mt-4 features-item-list">
            {#each feature_list as list}
              <li class="">{list}</li>
            {/each}
          </ul>
          <!-- <a href="{'#'}" class="btn btn-primary mt-4 waves-effect waves-light"
            >Learn More <i class="mdi mdi-arrow-right" /></a
          > -->
        </div>
      </Col>
      <Col lg="7">
        <div class="features-img features-right text-end">
          <img
            src="images/certifications/veteran_owned.png"
            alt="macbook"
            class="img-fluid"
          />
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!--END ABOUT US-->

<!--START WEBSITE-DESCRIPTION-->
<section class="section section-lg bg-web-desc">
  <div class="bg-overlay" />
  <Container>
    <Row>
      <Col lg="12" class="text-center">
        <h2 class="text-white">Protect your investment</h2>
        <p class="pt-3 home-desc">
          Invest in a high-quality home inspection. 
        </p>
        <a href="{'#contact'}" class="btn btn-white mt-4 waves-effect waves-light mb-5"
          >Get In Touch</a
        >
      </Col>
    </Row>
  </Container>
  <div class="bg-pattern-effect">
    <img src="images/bg-pattern.png" alt="" />
  </div>
</section>

<!--END WEBSITE-DESCRIPTION-->
